import { aiStudioModuleNavigationItems } from '../../features/admin/ai/aiStudioModules';

export const aiAndAgentPages = [
  {
    id: 'agent',
    label: 'Agent',
    title: 'Agent workspace',
    description: 'Review a selected AI agent client, rotate credentials, disable access, or revoke it.',
    hidden: true,
  },
  {
    id: 'ai-studio-agent-client',
    label: 'MCP client',
    title: 'MCP client workspace',
    description: 'Review and manage a ChatGPT connector client inside AI Studio.',
    hidden: true,
  },
  {
    id: 'agent-api-submissions',
    label: 'Agent submissions',
    title: 'Agent submission management',
    description: 'Review, approve, publish, reject, or remove full uploads submitted through the Agent API.',
    hidden: true,
  },
  {
    id: 'agent-api-mock-exams',
    label: 'Agent mock exams',
    title: 'Agent mock exam management',
    description: 'Review and publish mock exams submitted through the Agent API.',
    hidden: true,
  },
  {
    id: 'agent-api-mock-exam',
    label: 'Agent mock exam',
    title: 'Agent mock exam workspace',
    description: 'Review, edit, approve, and publish a generated mock exam using the admin mock exam workflow.',
    hidden: true,
  },
  {
    id: 'ai-studio-assisted-mock-exam-new',
    label: 'New mock exam',
    title: 'New mock exam',
    description: 'Create a platform-managed compact prompt for ChatGPT to complete through AI Studio MCP.',
    hidden: true,
  },
  {
    id: 'ai-studio-assisted-mock-exam-review',
    label: 'MCP mock exam review',
    title: 'MCP mock exam review',
    description: 'Review a completed ChatGPT-assisted mock exam with questions, answers, and worked solutions.',
    hidden: true,
  },
  {
    id: 'ai-studio-predicted-paper-new',
    label: 'New predicted paper',
    title: 'New predicted paper',
    description: 'Configure and generate a Predicted Paper through the backend-owned AI Studio workflow.',
    hidden: true,
  },
  {
    id: 'ai-studio-predicted-paper-review',
    label: 'Predicted paper review',
    title: 'Predicted paper review',
    description: 'Review, revise, approve, and publish an AI Studio Predicted Paper draft.',
    hidden: true,
  },
  {
    id: 'ai-studio-question-new',
    label: 'Generate questions',
    title: 'Generate AI questions',
    description: 'Configure standalone Question Bank generation inside AI Studio.',
    hidden: true,
  },
  {
    id: 'ai-studio-question',
    label: 'Generated question',
    title: 'Generated question workspace',
    description: 'Review and publish an AI Studio question draft.',
    hidden: true,
  },
  {
    id: 'agent-api-predicted-papers',
    label: 'Agent predicted papers',
    title: 'Agent predicted paper management',
    description: 'Review and publish predicted papers submitted through the Agent API.',
    hidden: true,
  },
  {
    id: 'agent-api-predicted-paper',
    label: 'Agent predicted paper',
    title: 'Agent predicted paper workspace',
    description: 'Review, edit, approve, and publish a generated predicted paper using the admin predicted paper workflow.',
    hidden: true,
  },
  {
    id: 'agent-api-topics',
    label: 'Agent topics',
    title: 'Agent topic management',
    description: 'Review and publish topics submitted through the Agent API.',
    hidden: true,
  },
  {
    id: 'agent-api-topic',
    label: 'Agent topic',
    title: 'Agent topic workspace',
    description: 'Review, edit, approve, and publish a generated topic using the admin topic workflow.',
    hidden: true,
  },
  {
    id: 'agent-api-units',
    label: 'Agent units',
    title: 'Agent unit management',
    description: 'Review and publish units submitted through the Agent API.',
    hidden: true,
  },
  {
    id: 'agent-api-unit',
    label: 'Agent unit',
    title: 'Agent unit workspace',
    description: 'Review, edit, approve, and publish a generated unit using the admin unit workflow.',
    hidden: true,
  },
  {
    id: 'ai-studio-topic-generation',
    label: 'Topic generation',
    title: 'Topic generation',
    description: 'Review ChatGPT-generated topic drafts inside AI Studio.',
    hidden: true,
  },
  {
    id: 'ai-studio-topic-generation-topic',
    label: 'Generated topic',
    title: 'Generated topic workspace',
    description: 'Review, edit, approve, and publish a ChatGPT-generated topic inside AI Studio.',
    hidden: true,
  },
  {
    id: 'ai-studio-unit-generation',
    label: 'Unit generation',
    title: 'Unit generation',
    description: 'Review ChatGPT-generated unit drafts inside AI Studio.',
    hidden: true,
  },
  {
    id: 'ai-studio-unit-generation-unit',
    label: 'Generated unit',
    title: 'Generated unit workspace',
    description: 'Review, edit, approve, and publish a ChatGPT-generated unit inside AI Studio.',
    hidden: true,
  },
  {
    id: 'agent-api-questions',
    label: 'Agent questions',
    title: 'Agent question management',
    description: 'Review and publish questions submitted through the Agent API.',
    hidden: true,
  },
  {
    id: 'agent-api-question',
    label: 'Agent question',
    title: 'Agent question workspace',
    description: 'Review, edit, approve, and publish a generated question using the admin question workflow.',
    hidden: true,
  },
  {
    id: 'agent-api-sqs',
    label: 'Agent SQS',
    title: 'Agent SQS management',
    description: 'Monitor intake queues, dead-letter messages, retryable jobs, and worker status.',
    hidden: true,
  },
  {
    id: 'agent-api-metrics',
    label: 'Agent metrics',
    title: 'Agent API metrics',
    description: 'Review Agent API volume, job health, and operational intake metrics.',
    hidden: true,
  },
  {
    id: 'agent-api-documentation',
    label: 'Agent documentation',
    title: 'Agent API documentation',
    description: 'Prompting guidance for external agents that create draft content through the Agent API.',
    hidden: true,
  },
  {
    id: 'ai-studio',
    label: 'AI Studio',
    title: 'AI Studio',
    description: 'Open a focused workspace for each AI generation, review, or connector activity.',
    children: aiStudioModuleNavigationItems,
  },
  {
    id: 'agent-api',
    label: 'Agent API',
    title: 'Agent API',
    description: 'Manage AI agent clients, credentials, auth scopes, and access lifecycle.',
    children: [
      { id: 'agent-api-submissions', label: 'Submission management' },
      { id: 'agent-api-mock-exams', label: 'Mock exam management' },
      { id: 'agent-api-predicted-papers', label: 'Predicted paper management' },
      { id: 'agent-api-topics', label: 'Topic management' },
      { id: 'agent-api-units', label: 'Unit management' },
      { id: 'agent-api-questions', label: 'Question management' },
      { id: 'agent-api-sqs', label: 'SQS management' },
      { id: 'agent-api-metrics', label: 'Metrics' },
      { id: 'agent-api-documentation', label: 'Documentation' },
    ],
  },
];
